import { getContentImageProps } from '@/lib/utils';
import ExternalLink from '@/components/elements/ExternalLink';

export default async function MattressBanner({ block, position }) {
  const {
    mobile_image,
    tablet_image,
    desktop_image,
    image_alt_copy,
    header,
    subtext,
    mattress_banner_button,
    _metadata: { uid }
  } = block.mattress_banner;

  return (
    <section
      id={`${uid}_${position}`}
      data-name="mattress-banner"
      className={`relative flex h-175 flex-col justify-end sm:h-115 sm:flex-row sm:items-center sm:justify-start lg:h-105`}
    >
      <MattressBannerImage
        mobileImage={mobile_image}
        tabletImage={tablet_image}
        desktopImage={desktop_image}
        alt={image_alt_copy}
      />

      <div className="relative flex h-1/2 w-full flex-col items-center justify-center sm:h-full sm:w-1/2 sm:min-w-96 sm:flex-row">
        <div className="w-full px-5 sm:w-2/3">
          <h2 className="mb-5 text-center sm:text-left">
            <span className="h4 sm:h2 text-crisp-white">{header}</span>
          </h2>

          <div className="mb-10 text-center sm:text-left">
            <span className="body-l text-crisp-white mx-auto block max-w-162.5 min-w-full sm:contents sm:max-w-full sm:min-w-157.5">
              {subtext}
            </span>
          </div>

          <div className="text-center sm:text-left">
            <div>
              {mattress_banner_button.banner_button_link &&
                mattress_banner_button.banner_button_copy && (
                  <ExternalLink
                    linkStyling="btn btn-primary inline-block sm:w-full lg:w-auto"
                    internalLink={
                      mattress_banner_button.banner_button_link?.[0]?.url
                    }
                    linkText={mattress_banner_button.banner_button_copy}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/**
 * The main background banner image (takes in mobile, tablet, and desktop images).
 */
const MattressBannerImage = ({
  mobileImage,
  tabletImage,
  desktopImage,
  alt
}) => {
  const { srcSet: desktopSrcSet } = getContentImageProps({
    image: desktopImage
  });
  const { srcSet: tabletSrcSet } = getContentImageProps({
    image: tabletImage
  });
  const { srcSet: mobileSrcSet, remainingProps } = getContentImageProps({
    image: mobileImage
  });

  return (
    <picture>
      <source media="(max-width: 639px)" srcSet={mobileSrcSet} />
      <source media="(max-width: 1024px)" srcSet={tabletSrcSet} />
      <source srcSet={desktopSrcSet} />
      <img
        className="absolute top-0 left-0 h-full w-full object-cover"
        {...remainingProps}
        alt={alt}
      />
    </picture>
  );
};
